type MaskedCardNumberProps = {
  lastFourDigits: string | null | undefined;
};

export const MaskedCardNumber = ({ lastFourDigits }: MaskedCardNumberProps) => {
  return lastFourDigits ? (
    <>{`***${lastFourDigits[0]} ${lastFourDigits.slice(1, 4)}`}</>
  ) : (
    <></>
  );
};
